import {css} from 'lit';
import {customElement} from 'lit/decorators.js';
import {FilterView} from './filter-view';
import global_css from './global-css';
import {UnlockableLitElement} from './unlockable';

// Unlockables display

@customElement('ri-unlockables')
export class Unlockables extends FilterView {
  override name = '可解锁';
  override replace = true;
  override subtitle = '你下一步要做什么？';
  override possibleFilters = new Set([
    {name: 'activity', displayName: 'Activity'},
    {name: 'stat', displayName: 'Stat'},
    {name: 'resource', displayName: 'Resource'},
    {name: 'spell', displayName: 'Spell'},
    {
      name: 'hidden',
      displayName: 'Hidden',
      condition: (item) => !item.visible,
    },
    {
      name: 'unlocked',
      displayName: 'Locked Only',
      condition: (item) => !item.unlocked,
      only: true,
    },
    {
      name: 'undiscovered',
      displayName: 'Undiscovered Only',
      condition: (item) => item.secret,
      only: true,
    },
  ]);
  override filters = new Set(['activity', 'stat', 'resource', 'spell']);

  static override styles = [
    ...FilterView.styles,
    css`
      .filters,
      .container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
      }
      .container * {
        margin: 4px;
      }
    `,
  ];

  override compare(a: UnlockableLitElement, b: UnlockableLitElement) {
    a = a.filterable;
    b = b.filterable;
    if (a.unlocked && !b.unlocked) return -1;
    if (!a.unlocked && b.unlocked) return 1;
    // if (a.new && !b.new) return -1;
    // if (!a.new && b.new) return 1;
    if (a.unlocked && b.unlocked) {
      // if (a.displayName < b.displayName) return -1;
      // if (a.displayName > b.displayName) return 1;
    }
    if (!a.unlocked && !b.unlocked) {
      if (a.secret && !b.secret) return 1;
      if (!a.secret && b.secret) return -1;
      if (!a.visible && b.visible) return 1;
      if (a.visible && !b.visible) return -1;
      if (a.conditionString < b.conditionString) return -1;
      if (a.conditionString > b.conditionString) return 1;
    }
    return a.compareDocumentPosition(b);
  }
}
